var render = function render(){var _vm=this,_c=_vm._self._c;return _c('steps-screen',{staticClass:"redeem-integration",attrs:{"step":_vm.stepperCurrentStep}},[_c('redeem-stepper',{attrs:{"slot":"stepper","currentStep":_vm.stepperCurrentStep},slot:"stepper"}),(!_vm.redeemed)?_c('sky-redeem-step',{on:{"subscriptionCreated":function($event){_vm.redeemed = true}}}):_c('sky-success-step')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }